import { Trans, useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { EasyPayStopForm } from 'containers/Premiums/components/EasyPay/EasyPayStopForm/EasyPayStopForm'
import { Redirect, useHistory } from 'react-router'
import { useEasyPayStop, useEasyPaySummary } from 'queries/premiums'
import EasyPayServerErrorAlert from 'containers/Premiums/components/EasyPay/EasyPayServerErrorAlert/EasyPayServerErrorAlert'
import { Divider } from 'components/Divider/Divider'
import PrivacyActNotice from 'containers/Premiums/components/EasyPay/PrivacyActNotice/PrivacyActNotice'
import { BackToEasyPayBreadcrumb } from 'containers/Premiums/components/EasyPay/BackToEasyPayBreadcrumb'
import { Component } from '@cms-max/medicare-api-sdk'
import { useEvent } from 'hooks/useEvent'

export function EasyPayStopPage () {
  const { t } = useTranslation('easyPayStopPage')
  const history = useHistory()
  const { fireEvent } = useEvent('premiumsEasyPay')

  const {
    mutate,
    data: mutationResult,
    error,
    isError,
    isLoading,
    isSuccess
  } = useEasyPayStop()

  const handleCancel = () => {
    history.push('/premiums/easy-pay')
  }
  const handleSubmit = async () => {
    fireEvent('premiums_easypaystop_submit_click')
    await mutate()
  }

  // If we haven't fetched the summary data, redirect back to the summary page.
  const { isFetched } = useEasyPaySummary()
  if (!isFetched) {
    return <Redirect to="/premiums/easy-pay" />
  }

  if (isSuccess) {
    return (
      <Redirect
        to={{
          pathname: '/premiums/easy-pay/stop/success',
          search: `?date=${mutationResult?.completedAt}`
        }}
      />
    )
  }

  if (isError && ['409', '503'].includes(String(error?.response?.status))) {
    return (
      <Redirect
        to={{
          pathname: '/premiums/easy-pay/error',
          search: `?code=${
            error?.response?.status === 409 ? 'ineligible' : 'unavailable'
          }`
        }}
      />
    )
  }

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      nav={<BackToEasyPayBreadcrumb />}
      heading={t('heading')}
      width="wide"
      withPrintButton
      printComponent={Component.EasyPay}
    >
      <div className="ds-l-container">
        <div className="ds-u-measure--wide">
          <Trans t={t} i18nKey="description" />
          <EasyPayStopForm
            className="ds-u-margin-top--4"
            loading={isLoading}
            onCancel={handleCancel}
            onSubmit={handleSubmit}
          />

          {isError && (
            <EasyPayServerErrorAlert className="ds-u-margin-top--3" />
          )}
        </div>

        <Divider className="ds-u-margin-top--7 ds-u-margin-bottom--3" />
        <PrivacyActNotice />
      </div>
    </ContentLayout>
  )
}
